import React from 'react';
export function CornerFrame({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`relative border border-bio-gray/50 bg-bio-dark/50 p-8 ${className}`} data-id="element-286">
      <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-bio-teal" data-id="element-287" />
      <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-bio-teal" data-id="element-288" />
      <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-bio-teal" data-id="element-289" />
      <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-bio-teal" data-id="element-290" />
      {children}
    </div>;
}